(function() {
  document.addEventListener('change', function(e) {
    const input = e.target.closest('input[data-variant-media]');
    if (!input) return;

    const card = e.target.closest('product-card');
    if (!card) return;

    const primaryImg   = card.querySelector('.product-card__image--primary');
    const secondaryImg = card.querySelector('.product-card__image--secondary');

    let media = null;
    try { media = JSON.parse(input.dataset.variantMedia || 'null'); } catch(_) {}
    if (!media || !media.preview_image || !media.preview_image.src) return;

    // 1枚目を差し替え
    primaryImg && (primaryImg.src = media.preview_image.src, primaryImg.srcset = '');

    // 2枚目（ホバー用）があれば差し替え
    let sec = null;
    try { sec = JSON.parse(input.dataset.variantSecondaryMedia || 'null'); } catch(_) {}
    if (secondaryImg && sec && sec.preview_image && sec.preview_image.src) {
      secondaryImg.src = sec.preview_image.src;
      secondaryImg.srcset = '';
    }
  });
})();
